(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('GasEventController', function(
            $rootScope,
            $scope,
            $state,
            $stateParams,
            moment,
            Content,
            ContractorFilter,
            EventFilter,
            HelpersService
        ) {
            var vm = this;

            $scope.$on('languageChange', function() {
                vm.updateDateFrom();
                vm.updateDateTo();
            });

            $scope.$watch('event.dateFrom', function(date) {
                vm.dateFromFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            $scope.$watch('event.dateTo', function(date) {
                vm.dateToFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            $scope.$on('contractorsSet', function(event, contractors) {
                vm.contractors = contractors;
                vm.eventFilter = EventFilter.getEventFilter(
                    vm.dateFrom,
                    vm.dateTo,
                    vm.contractors,
                    vm.eventTypes,
                    vm.dictionaries,
                    $stateParams.contractor
                );
            });

            vm.sort = {
                id: 1
            };
            vm.events = [];
            vm.filters = {};
            vm.eventFilter = {};
            vm.dictionaries = {
                assentNames: []
            };
            vm.isIframe = $state.current.data.iframe;
            vm.sortOptions = EventFilter.getSortOptions();
            vm.config = HelpersService.getPaginationConfig();
            vm.contractors = ContractorFilter.getGlobalContractors();

            function getStateName() {
                return $state.current.name + '_' + $stateParams.commodity;
            }

            function initDates() {
                var prevFilters = HelpersService.loadPreviusFilters(getStateName());

                vm.contractors = ContractorFilter.getContractors();
                vm.eventTypes = EventFilter.getEventTypes();

                if (!_.isEmpty(prevFilters)) {
                    vm.dateFrom = prevFilters.dateFrom;
                    vm.dateTo = prevFilters.dateTo;
                    EventFilter.markContractorsSelected(vm.contractors, prevFilters.contractor);
                    EventFilter.markEventTypesSelected(vm.eventTypes, prevFilters.eventTypes);
                    EventFilter.markAssentNamesSelected(vm.dictionaries.assentNames, prevFilters.assentNames);
                    vm.eventFilter.contractor = prevFilters.contractor;
                    vm.eventFilter.eventTypes = prevFilters.eventTypes;
                    vm.eventFilter.assentNames = prevFilters.assentNames;
                } else {
                    vm.dateFrom = moment().startOf('day');
                    vm.dateTo = moment().endOf('day');
                    vm.eventFilter.contractor = EventFilter.getSelectedcontractors(vm.contractors, $stateParams.contractor);
                    vm.eventFilter.eventTypes = [];
                }

                vm.eventFilter = {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor,
                    eventTypes: vm.eventFilter.eventTypes,
                    assentNames: EventFilter.getAssentNames(vm.dictionaries.assentNames)
                };
            }

            function loadAll() {
                EventFilter.loadAll('gas', vm.config, vm.eventFilter, vm.sort, function(result) {
                    vm.events = result.content;
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { totalElements: result.totalElements }));
                });
            }

            vm.setPage = function(page) {
                if (vm.config.page !== page) {
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { page: page }));

                    loadAll();
                }
            };

            vm.searchEvent = function() {
                vm.eventFilter = EventFilter.getEventFilter(
                    vm.dateFrom,
                    vm.dateTo,
                    vm.contractors,
                    vm.eventTypes,
                    vm.dictionaries,
                    $stateParams.contractor
                );

                loadAll();
            };

            vm.updateDateFrom = function() {
                var momented = moment(vm.dateFromFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateFrom = momented.startOf('day');
                }
            };

            vm.updateDateTo = function() {
                var momented = moment(vm.dateToFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateTo = momented.endOf('day');
                }
            };

            vm.viewDetails = function(event) {
                var commodity = Content.getCommodity(event.mode.toLowerCase());
                var goState = (vm.isIframe ? 'iframe' : 'event') + '-versions';

                HelpersService.setPreviusFilters(getStateName(), {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor,
                    eventTypes: vm.eventFilter.eventTypes
                });

                $state.go(goState, {
                    messageId: event.messageId.slice(0, -4),
                    contractor: $stateParams.contractor,
                    commodity: commodity
                });
            };

            vm.excelLink = function() {
                return EventFilter.excelLink(vm.eventFilter);
            };

            vm.$onInit = function() {
                EventFilter.getAssentNamesData()
                    .query()
                    .$promise.then(function(response) {
                        vm.dictionaries.assentNames = _.map(
                            _.filter(response, function(assentName) {
                                return assentName;
                            }),
                            function(assentName) {
                                return { name: assentName };
                            }
                        );
                        initDates();
                        loadAll();
                    });
            };
        });
})();
